export default {
  red: 'rgb(255, 23, 38)',
}
